import 'css-chunksrc/client/scenes/optimizedGantt/workloads/calendar/styles.scss';export default {
  "calendar": "_calendar_1rsof_1",
  "groupCalendar": "_groupCalendar_1rsof_1",
  "main": "_main_1rsof_6",
  "grid": "_grid_1rsof_11",
  "workLoads": "_workLoads_1rsof_18",
  "workLoad": "_workLoad_1rsof_18",
  "day": "_day_1rsof_29",
  "good": "_good_1rsof_40",
  "bad": "_bad_1rsof_44",
  "worse": "_worse_1rsof_48",
  "restDay": "_restDay_1rsof_52"
};